import { useState } from "react";
import { useData } from "./DataContext.js";

import * as utils from "./utils.js";

import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

//import FormGroup from "./FormGroup.js"; // TODO : use FormGroup.js
import ButtonGrid from "./ButtonGrid.js";

export default function TeacherNewSimModal (props)
{
    const [validated, setValidated] = useState(false);

    const [title, setTitle] = useState("");
    const [institutionContentID, setInstitutionContentID] = useState("");
    const [scenarioContentID, setScenarioContentID] = useState("");
    const [durationContentID, setDurationContentID] = useState("");

    function handleTitleChange (e) { setTitle(e.target.value); }
    function handleInstitutionChange (e) { setInstitutionContentID(e.target.value); }
    function handleScenarioChange (e) { setScenarioContentID(e.target.value); }
    function handleDurationChange (e) { setDurationContentID(e.target.value); }

    function hide ()
    {
	props.hide();
	setTitle("");
	setInstitutionContentID("");
	setScenarioContentID("");
	setDurationContentID("");
	setValidated(false);
    }
    
    function handleHide (e) { hide(); }

    function handleSubmit (e)
    {
	e.preventDefault();
	if (e.target.checkValidity()) {
	    props.submit({ title, institutionContentID, scenarioContentID, durationContentID });
	    hide();
	}

	else setValidated(true);
    }

    const gData = useData();
    const institutionContentOptions = Object.entries(gData.institutionContent).map(([id, content]) => (<option value={id} key={id}>{content.title}</option>));
    const scenarioContentOptions = Object.entries(gData.scenarioContent).map(([id, content]) => (<option value={id} key={id}>{content.title}</option>));
    const durationContentOptions = Object.entries(gData.durationContent).map(([id, content]) => (<option value={id} key={id}>{content.title}</option>));

    return (
	<Modal
	    size="xl"
	    show={props.show}
	    onHide={handleHide}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Créer une nouvelle SIM</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form
		    id="signinForm"
		    noValidate validated={validated}
		    onSubmit={handleSubmit}
		>
		    <div className="d-flex flex-column gap-3">
			<div className="d-flex justify-content-between">
			    <Form.Group controlId="signinForm.title" className="d-flex flex-column">
				<Form.Label className="text-muted text-uppercase">Titre de votre SIM</Form.Label>
				<Form.Control
				    type="text"
				    required
				    autoFocus
				    value={title}
				    onChange={handleTitleChange}
				/>
			    </Form.Group>
			    
			    <div>
				<Form.Group controlId="signinForm.date" className="d-flex flex-column">
				    <Form.Label className="text-muted text-uppercase">Date de création</Form.Label>
				    <Form.Control type="text" placeholder={utils.currentTimeToString()} disabled readOnly/>
				</Form.Group>
			    </div>
			</div>

			<div className="d-flex justify-content-between gap-3">
			    <div className="d-flex flex-column w-100 gap-2">
				<Form.Group controlId="signinForm.institution">
				    <Form.Label className="text-muted text-uppercase">Institution</Form.Label>
				    <Form.Select
					required
					value={institutionContentID}
					onChange={handleInstitutionChange}
				    >
					<option hidden value="">Sélectionner</option>
					{institutionContentOptions}
				    </Form.Select>
				</Form.Group>

				<Container className="overflow-auto border py-2 text-muted" style={{ height: 300 }}>
				    {institutionContentID !== "" && gData.institutionContent[institutionContentID].description}
				</Container>
			    </div>

			    <div className="d-flex flex-column w-100 gap-2">
				<Form.Group controlId="signinForm.scenario">
				    <Form.Label className="text-muted text-uppercase">Thématique</Form.Label>
				    <Form.Select
					required
					value={scenarioContentID}
					onChange={handleScenarioChange}
				    >
					<option hidden value="">Sélectionner</option>
					{scenarioContentOptions}
				    </Form.Select>
				</Form.Group>

				<Container className="overflow-auto border py-2 text-muted" style={{ height: 300 }}>
				    {scenarioContentID !== "" && gData.scenarioContent[scenarioContentID].description}
				</Container>
			    </div>
			    
			    <div className="d-flex flex-column w-100 gap-2">
				<Form.Group controlId="signinForm.duration">
				    <Form.Label className="text-muted text-uppercase">Format</Form.Label>
				    <Form.Select
					required
					value={durationContentID}
					onChange={handleDurationChange}
				    >
					<option hidden value="">Sélectionner</option>
					{durationContentOptions}
				    </Form.Select>
				</Form.Group>

				<Container className="overflow-auto border py-2 text-muted" style={{ height: 300 }}>
				    {durationContentID !== "" && gData.durationContent[durationContentID].description}
				</Container>
			    </div>
			</div>
		    </div>
		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="primary" size="md" type="submit" form="signinForm">Créer la SIM</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
